import styled from "styled-components";

export const TrendingLessonsLoadingSkeletonContainer = styled.div`
  display: flex;
  gap: 12px;

  margin: 0 0 40px 20px;

  @media (min-width: 600px) {
    margin: 0 0 40px 55px;
  }

  .index {
    font: 600 2.5rem/150% "Inter";

    background: linear-gradient(
      180deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0.6) 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .texts {
    display: flex;
    gap: 8px;
    align-items: center;

    .skeleton {
      width: 100%;
    }
  }

  .image > div {
    @media (max-width: 1366px) {
      height: 131.64px;

      width: auto;
      aspect-ratio: 16/9;
    }

    @media (max-width: 500px) {
      height: 92.39px;
    }
  }
`;
